import Start from './Start.page';

export default Start;
